import { Modal } from "ant-design-vue";
import SelectPrinterModal from "@/components/UI/SelectPrinterModal.vue";
import { useQzTrayStore } from "@/stores/qzTray/qzTrayStore";
import { h } from "vue";

export const selectPrinterModal = () => {
  const qzTrayStore = useQzTrayStore();

  return new Promise<string>((resolve) => {
    qzTrayStore.connectToQzTray().then((connected) => {
      if (connected) {
        openModal(resolve);
      }
    });
  });
};

const openModal = (resolve: (value: string) => void) => {
  const modal = Modal.confirm({
    title: "Выберите принтер",
    content: h(SelectPrinterModal, {
      onPrinterSelected: (printerName: string) => {
        resolve(printerName);
        modal.destroy();
      },
      onClose: () => {
        modal.destroy();
      },
    }),
    footer: null,
    width: "fit-content",
    centered: true,
  });
};
